if (!customElements.get('component-cart-footer')) {
  customElements.define('component-cart-footer', class CartFooter extends HTMLElement {
    constructor() {
      super();

      this.subtotalWrapper = this.querySelector('.js-cart-footer-subtotal-wrapper');
      this.discountWrapper = this.querySelector('.js-cart-footer-discount-wrapper');
      this.discountCodesWrapper = this.querySelector('.js-discunt-codes-wrapper');
      this.subtotal = this.querySelector('.js-cart-footer-subtotal');
      this.discount = this.querySelector('.js-cart-footer-discount');
      this.freeShippingEl = this.querySelector('.js-cart-footer-shipping');
      this.total = this.querySelector('.js-cart-footer-total');
      this.checkoutButton = this.querySelector('.js-checkout-button');
      this.afterpayMessage = document.querySelector('.js-afterpay-message');

      this.countryCode = window.Shopify.country;
      this.discountCode = '';
      this.discountCookie = 'discount_code';
      this.fsEnabled = this.dataset.fsEnabled === 'true',
      this.fsThreshold = +this.dataset.fsThreshold;
      this.displayDiscountCodes = +this.dataset.displayDiscountCodes;
      this.afterpayEnabled = this.dataset.afterpayEnabled === 'true';
      if (this.afterpayEnabled) {
        this.afterpayMinimumValue = this.dataset.afterpayMinimumValue || 3500;
        this.afterayNumberOfInstallments = this.dataset.afterayNumberOfInstallments || 4;
        this.logo = this.dataset.logo || 'Afterpay';
      }

      this.getDiscountCode().then(this.setEventListeners());
    }

    setEventListeners() {
      this.checkoutButton?.addEventListener('click', async () => {
        // Force the cart to be updated when user go back to the cart page or home
        sessionStorage.removeItem('cart_settings');

        if (this.discountCode) {
          window.location.href = `${window.location.origin}/checkout?discount=${this.discountCode}`;
        } else {
          window.location.href = `${window.location.origin}/checkout`;
        }
      });

      window.addEventListener('update-cart-footer-prices', () => {
        const cart = window.cartManager.getLocalCart();
        if (cart.original_total_price !== cart.total) {
          this.subtotal.textContent = toMoney(cart.original_total_price, { currencyDisplay: 'code', no_zeros: false });
          this.subtotalWrapper.classList.remove('hidden');
        } else {
          this.subtotalWrapper.classList.add('hidden');
        }

        if (cart.discount) {
          this.discount.textContent = toMoney(cart.discount, { is_discount: true, currencyDisplay: 'code', no_zeros: false });
          this.discountWrapper.classList.remove('hidden');
        } else {
          this.discountWrapper.classList.add('hidden');
        }

        if (this.discountCodesWrapper && this.displayDiscountCodes === 1 && cart.discount_codes?.length) {
          let htmlCode = '';
          cart.discount_codes.forEach(discountCode => {
            htmlCode += `
              <div class="component-cart-footer__price-wrapper">
                <label class="component-cart-footer__price-text--discount-code">${ discountCode.title.toUpperCase() }:</label>
                <label class="component-cart-footer__price-number--discount js-cart-footer-discount-code-${discountCode.title?.toLowerCase()}">${toMoney(discountCode.amount, { is_discount: true, currencyDisplay: 'code', no_zeros: false })}</label>
              </div>
            `;
          });
          this.discountCodesWrapper.innerHTML = htmlCode;
        } else if (this.discountCodesWrapper) {
          this.discountCodesWrapper.innerHTML = '';
        }

        if (this.fsEnabled && this.freeShippingEl) {
          if (cart.discount_codes.some(discount => discount.title.startsWith('TLEMP-'))) {
            this.freeShippingEl.textContent = 'Free (TL employee)';
          } else if (window.theme?.loyalty.customer?.tier_ordinal && cart.total >= window.theme?.loyalty[`loyalty_${window.theme?.loyalty.customer?.tier_ordinal}_tier_free_shipping_threshold`]) {
            this.freeShippingEl.textContent = window.theme.loyalty.customer.tier_name ? `Free (${window.theme.loyalty.customer.tier_name})` : 'Free';
          } else if (this.fsThreshold && (cart.total >= this.fsThreshold)) {
            this.freeShippingEl.textContent = 'Free';
          } else {
            this.freeShippingEl.textContent = 'Calculated at next step';
          }
        }

        this.total.textContent = toMoney(cart.total, { currencyDisplay: 'code', no_zeros: false });

        if (this.afterpayEnabled) {
          if (cart.total >= this.afterpayMinimumValue) {
            const installmentPrice = toMoney(cart.total / this.afterayNumberOfInstallments);
            this.afterpayMessage.innerHTML = `Or ${this.afterayNumberOfInstallments} payments of ${installmentPrice} by ${this.logo}`;
          } else {
            const afterpayMinimumValue = toMoney(this.afterpayMinimumValue);
            this.afterpayMessage.innerHTML = `Installments by ${this.logo}is available over ${afterpayMinimumValue}`;
          }
        }

        if (!cart.item_count) {
          this.checkoutButton.disabled = true;
        } else {
          this.checkoutButton.disabled = false;
        }
      });

      window.addEventListener('show-cart-footer', () => {
        document.querySelector('.component-cart-footer').classList.remove('hidden');
      });

      window.addEventListener('hide-cart-footer', () => {
        document.querySelector('.component-cart-footer').classList.add('hidden');
      });
    }

    async getDiscountCode() {
      const params = getURLParams();
      if (params.discount) {
        this.discountCode = params.discount;
      } else {
        const discountCookieValue = jsCookie.get(this.discountCookie);
        this.discountCode = discountCookieValue || '';
      }
    }
  });
}
